export const FILE_LIST_HEADERS = ['FILE NAME', 'LENGTH'];
export const AUDIO_FILE_ACCEPT = '.mp3,audio/wav';

// todo configuration 으로 분리 필요, 이후 추가적인 개인사용화에 대한 작업 진행시 분리
export const RESULT_TOGGLE_DEFAULT_VALUE = true;
